/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceCommercialCreate } from '../models/InvoiceCommercialCreate';
import type { InvoiceCommercialResponse } from '../models/InvoiceCommercialResponse';
import type { InvoiceCommercialUpdate } from '../models/InvoiceCommercialUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoiceCommercialService {
    /**
     * List Invoice Commercials
     * @returns InvoiceCommercialResponse Successful Response
     * @throws ApiError
     */
    public static listInvoiceCommercialsInvoicesCommercialsGet(): CancelablePromise<Array<InvoiceCommercialResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/commercials/',
        });
    }
    /**
     * Create Invoice Commercial
     * @param requestBody
     * @returns InvoiceCommercialResponse Successful Response
     * @throws ApiError
     */
    public static createInvoiceCommercialInvoicesCommercialsPost(
        requestBody: InvoiceCommercialCreate,
    ): CancelablePromise<InvoiceCommercialResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/commercials/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Invoice Commercial
     * @param id
     * @returns InvoiceCommercialResponse Successful Response
     * @throws ApiError
     */
    public static getInvoiceCommercialInvoicesCommercialsIdGet(
        id: number,
    ): CancelablePromise<InvoiceCommercialResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/commercials/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Invoice Commercial
     * @param id
     * @param requestBody
     * @returns InvoiceCommercialResponse Successful Response
     * @throws ApiError
     */
    public static updateInvoiceCommercialInvoicesCommercialsIdPut(
        id: number,
        requestBody: InvoiceCommercialUpdate,
    ): CancelablePromise<InvoiceCommercialResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoices/commercials/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Invoice Commercial
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteInvoiceCommercialInvoicesCommercialsIdDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoices/commercials/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
